import CollectionCard from 'marketplace-ui-common/collections/components/CollectionCard';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import Carousel from 'marketplace-ui-common/components/Carousel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getIsInApp } from '../../selectors/app';
import { getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemeCollectionsCardGrid__StyledRouterLink",
  componentId: "sc-1c7dq6e-0"
})(["display:flex;align-items:stretch;"]);
export default function ThemeCollectionsCardGrid() {
  const isInApp = useSelector(getIsInApp);
  const {
    getDisplayedCollections,
    requestState
  } = usePublishedCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const {
    maxCardsPerPage
  } = useResponsiveProps({
    maxCardsPerPage: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const displayedCollections = getDisplayedCollections();
  const collectionCards = useMemo(() => displayedCollections.map(collection => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
    style: {
      height: '100%'
    },
    to: getThemesStorefrontRoute(collection.publishedListing.slug),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(CollectionCard, {
      collection: collection
    })
  }, `collection-${collection.id}`)), [displayedCollections]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: requestState,
    children: /*#__PURE__*/_jsx(Carousel, {
      cards: collectionCards,
      maxCardsPerPage: maxCardsPerPage
    })
  });
}